module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-gloves-2f3b07b0c717eaeab02ee6be420c4bc4.svg";